/** Situação fiscal (SITFIS): última conferência de cada cliente, novidades e a rotina mensal. */
import { z } from 'zod';
import { Id } from './comum.js';

export const SituacaoFiscalTipo = z.enum(['SEM_PENDENCIAS', 'COM_PENDENCIAS', 'NAO_LIDO', 'ERRO']);
export type SituacaoFiscalTipo = z.infer<typeof SituacaoFiscalTipo>;

export const SituacaoFiscalLinha = z.object({
  clienteId: Id,
  clienteNome: z.string(),
  documento: z.string(),
  /** null = nunca conferido */
  id: Id.nullable(),
  situacao: SituacaoFiscalTipo.nullable(),
  pendencias: z.array(z.string()),
  /** itens que não estavam na conferência anterior */
  novos: z.array(z.string()),
  erro: z.string().nullable(),
  temPdf: z.boolean(),
  tarefaId: Id.nullable(),
  origem: z.string().nullable(),
  consultadoEm: z.string().nullable(),
});
export type SituacaoFiscalLinha = z.infer<typeof SituacaoFiscalLinha>;

export const SituacaoFiscalPainel = z.object({
  linhas: z.array(SituacaoFiscalLinha),
  resumo: z.object({ semPendencias: z.number().int(), comPendencias: z.number().int(), naoLidos: z.number().int(), erros: z.number().int(), nuncaConferidos: z.number().int() }),
  /** cada conferência = 2 chamadas cobradas pelo SERPRO */
  chamadasPorCliente: z.number().int(),
  integraAtiva: z.boolean(),
  rotina: z.object({ ativa: z.boolean(), dia: z.number().int(), ultimaEm: z.string().nullable() }),
});
export type SituacaoFiscalPainel = z.infer<typeof SituacaoFiscalPainel>;

export const SituacaoFiscalRotinaBody = z.object({ ativa: z.boolean(), dia: z.number().int().min(1).max(28) });
export const SituacaoFiscalResultado = z.object({ id: Id, situacao: SituacaoFiscalTipo, pendencias: z.array(z.string()), novos: z.array(z.string()), tarefaId: Id.nullable(), erro: z.string().nullable() });
export type SituacaoFiscalResultado = z.infer<typeof SituacaoFiscalResultado>;
